import { animateScroll } from 'react-scroll';

export const scrollWithOffset = (el: HTMLElement, offset: number) => {
    const elementPosition = el.offsetTop + offset;
    animateScroll.scrollTo(elementPosition);
};